import { defineTranslateKeys } from 'lib/tolgee'

export const TOLGEE_KEYS = defineTranslateKeys({
  title: {
    key: 'SetupWorkspaceCategory-title',
    defaultValue: 'Configure o seu workspace',
  },
  descrition: {
    key: 'SetupWorkspaceCategory-descrition',
    defaultValue:
      'Dê o primeiro passo vinculando este workspace a uma das categorias abaixo para garantir o acesso às novas abas de Categoria e Zai.',
  },
  label: {
    key: 'SetupWorkspaceCategory-label',
    defaultValue: 'Qual categoria tem mais relação com a sua marca?',
  },
  placeholder: {
    key: 'SetupWorkspaceCategory-placeholder',
    defaultValue: 'Escolha sua categoria',
  },
  successMessage: {
    key: 'SetupWorkspaceCategory-successMessage',
    defaultValue: 'Seu Account Manager foi notificado e finalizará a configuração deste workspace.',
  },
})
